module.exports = __webpack_public_path__ + "static/s3-bg-4989c58f83ec6e31af24c924ccd89bfb.png";